import { render } from "./table-complexity.svg?vue&type=template&id=771d83ca?inline"
const script = {}
script.render = render

export default script